/**
 * Created by lu on 2017/9/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': ['upload-img', nb.bind('uploadWidth')],
        $html: [{
            'class': 'upload-wrap',
            $html: [{
                $name: 'inputFile',
                'class': 'img-input',
                tag: 'input',
                type: 'file',
                multiple: nb.bind('multiple'),
                // multiple: "multiple",//multiple 属性规定输入字段可选择多个值。如果使用该属性，则字段可接受多个值。
                accept: "image/png, image/jpeg, image/gif, image/jpg, image/bmp",
                style: {
                    display: 'none'
                }
            }, {
                'class': ['loading-wrap', nb.bind('loadingVisible')],
                $html: [{
                    tag: 'img',
                    src: './image/loading.gif'
                }, {
                    tag: 'span',
                    $text: '图片上传中...'
                }]
            }]
        }, {
            // tag: 'p',
            // $text: '支持JPG,PNG格式,最大10M'
        }, {
            'class': "img-list-wrap",
            $html: [{
                $name: 'selector',
                $type: nb.view.List,
                $model: 'imgList',
                'class': 'selector row'
            }]
        }, {
            'class': ['iconfont', nb.bind('icon')],
            tag: 'i',
            $text: nb.bind('iconText')
        }, {
            $name: 'text',
            'class': 'text',
            $text: nb.bind('text')
        }]
    },
    method: {
        init: function () {
            var self = this;
            var $inputFile = this.$('inputFile');

            //input 被点击
            $inputFile.on('change', function (inEvent) { // input
                self.getModel().set('selectedFile', $(this)[0]);
            });

            //点击上传图片 符号
            this.$().on('click', 'i', function () { //.$('selector')
                // $inputFile.trigger('click');
                $inputFile.click();
            });

            //点击绑定文字
            this.$().on('click', '.text', function () { //.$('selector')
                // $inputFile.trigger('click');
                $inputFile.click();
            });

            //点击删除图片 符号
            this.$('selector').$().on('click', '.img-item .delete', function () {
                //todo input $(input).val("")
                var index = $(this).parent().attr('data-list-index');
                $inputFile.val("");
                self.getModel().set('deleteIndex', index);
            });
        }
        // onModelReady:function (inModel) {
        //     var self =this;
        //     inModel.onChange('imgListReady',function (inEvnet) {
        //         var AddPic = require('./AddPic');
        //         var $selector = self.$('selector').$();
        //         var addPic=  new AddPic();
        //         $selector.append(addPic.$());
        //
        //     });
        // }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/view/uploadImg/uploadImg.js
// module id = 69
// module chunks = 3 4 8 19 25 29